import UploadAnalyses from "./components/UploadAnalyses";

export default UploadAnalyses